/**
 * The party call log routes — overnight v20 §D2, mounted through the `routes.extra.ts`
 * seam like every feature before them.
 *
 * TWO ROUTES, NO NAV ROW — and the omission is deliberate, not forgotten. `domain/nav.ts`
 * is the sidebar registry and its shape is pinned by `nav`'s own registry test; adding a
 * row there is an INFORMATION ARCHITECTURE decision (which section, what label, what
 * icon) that belongs to the owner, not to a build unit. The `parties/new` precedent is
 * exact: a screen can be reachable without being a sidebar row. Both of these are reached
 * from the Parties report's customer column, and by URL. (⚠ Since
 * feat/party-referral-screen the report's customer column points at the party RECORD,
 * which embeds the history panel and links here through its "Full log" action — so this
 * page is now one click further from the report, and still mounted for deep links.)
 *
 * Flagged in the morning report so the owner can rule on a sidebar row — the code change
 * is one entry in `NAV_SECTIONS` gated on `parties.view`, which both routes already are.
 *
 * NO PROVIDER LAYOUT — and the sentence that justified it changed once (v24 C1), so it
 * is re-argued rather than left stale: this used to read "two reads, no toast, no
 * mutation". The panel now MUTATES (the log-call flow and the amend path), but still no
 * toast: both flows report inline — success is the list refreshing with the new row,
 * failure is an Alert carrying the server's sentence — so a `ToastProvider` would still
 * be a stack with nothing to say.
 *
 * Both sit INSIDE `RequireCountry` + `AppShell`, so they can rely on `useCountryCode()`
 * and a resolved session.
 */

import type { RouteObject } from 'react-router-dom';

import { PartyCallRegisterPage } from './PartyCallRegisterPage';
import { PartyCallHistoryPage } from './PartyCallHistoryPage';

export const partyCallRoutes: RouteObject[] = [
  { path: 'party-calls', element: <PartyCallRegisterPage /> },
  { path: 'parties/:partyId/calls', element: <PartyCallHistoryPage /> },
];
